window.loaded = false;
var windowWidth = window.innerWidth;

$(window).on('load', function(){
	window.loaded = true;
});

var headerBorder = undefined;
var header = undefined;

$(document).ready(function() {
	/* MOBILE */
	//create js hook links
	windowWidth = window.innerWidth;
	var resizeFn = function() {
		if (windowWidth != window.innerWidth) {
			windowWidth = window.innerWidth;

			$(document).trigger('pwstudio.window_width_changed', windowWidth);
		}
	}

	window.addEventListener('resize', resizeFn);

	headerBorder = $('[data-purpose="header-scroll-border"]');
	header = $('.main-header');
	if (headerBorder.length === 0) {
		headerBorder = $('.main-header');
	}

	if (headerBorder && headerBorder.length > 0) {
		var headerScrollFn = function() {
			var height = headerBorder.outerHeight(true) + headerBorder.offset().top;
			var scrollTop = $(window).scrollTop()
	  
			if (height <= scrollTop && !header.hasClass('opened-fix-menu')) {
			  header.addClass('opened-fix-menu');
			  $('body').addClass('opened-fix-menu');
			} else if (height > scrollTop && header.hasClass('opened-fix-menu')) {
			  header.removeClass('opened-fix-menu');
	  
			  $('.main-header').find('.submenu').hide(0, function() {
				var submenu = $(this);
				setTimeout(function(){
				  submenu.removeAttr('style');
				}, 250);
			  });
			}
		  };
  
	  window.addEventListener('touchend', headerScrollFn);
	  window.addEventListener('touchmove', headerScrollFn);
	  window.addEventListener('scroll', headerScrollFn);
	}

	$('.mailtolink').click(function(e) {
		handleMailtoLink($(this));
	});

	$('[data-purpose="navigation-link"]').each(function(){
		setNavigationUrl($(this));
	});

	$('.remodal-open-button').click(function(){
		var target = $(this).data('popup-id');	
		openRemodalById(target);	
	});

	$('[data-purpose="scroll-to-element"]').click(function(){
		var target = $(this).data('target');
		var item = $(target);
		var timeout = $(this).data('timeout');
		if (isNaN(timeout)) {
			timeout = 400;
		}
		
		if (item.length > 0) {
			var top = item.offset().top;
			if (header && header.length == 1) {
				top -= (header.outerHeight(true) + 170);
			}
			$('html, body').animate({scrollTop: top}, timeout);
		}
	});

	$('select').change(function(){
		var value = parseInt($(this).val());
		
		if (!value && $(this).hasClass('has-value')) {
			$(this).removeClass('has-value');
		} else if (value && !$(this).hasClass('has-value')) {
			$(this).addClass('has-value');
		}
	}).change();

	$('.accordion-list').each(function(ind, el) {

		var options = {};
		var th = $(el);
		if (th.data('single-active-item') != undefined) options.singleActiveItem = true;
		if (th.data('active-index') != undefined) options.activeIndex = th.data('active-index');
		if (th.data('from-width') != undefined) options.fromWidth = parseInt(th.data('from-width'));
		
		new Accordion(th, options);
  });
	
  	if (typeof mediaGroupItems === 'object' && Object.keys(mediaGroupItems).length > 0) {
		$('[data-purpose="reference-gallery-item"]').click(function() {			
			openGallery($(this));
		});
	}

	$('[data-purpose="lang-chooser"]').change(function(){
		changeFrontendLang($(this));
	});

	$('[data-purpose="openable-title-row"]').click(function(){
		var parent = $(this).parent('.openable-row');
		if (parent && parent.length === 1) {
			parent.toggleClass('opened');
			parent.find('.text-content').slideToggle(300);
		}
	});

	$('.infinite-usp-section .inner-content').infiniteslide({
    	pauseonhover: false,
    	speed:60,
  	});

	$('.infinite-gallery-section .inner-content').each(function(index) {
        $(this).infiniteslide({
            pauseonhover: true,
            speed: 50,
            direction: 'left',
            clone: true
        });
    });

	$('[data-purpose="callback-button"]').on('click', function () {
		const type = $(this).data('type');
		const item = $(this).data('item');
		
		if (type && item) {
			$('#callbackFormModal').find(`.${type}`).val(item);
		}

		openRemodalById('callback-remodal');
	});
});

function openRemodalById(remodalId)
{
	if (!remodalId) {
		return;
	}

	const item = $('[data-remodal-id="'+remodalId+'"]');
	if (item.length == 1) {
		item.remodal().open();
	}
}

function changeFrontendLang(select) {
	var option = select.find(':selected');
	if (option && option.length == 1) {
		var url = option.data('url');
		if (url.trim() !== '') {
			document.location.href = url;
		}
	}	
}

function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

function sendAnalyticsEvent(action, category, tag) {
	if (typeof gtag !== 'undefined' && action && category) {
		var evtData = {
			event_category: category,
		};

		if (tag && tag.trim() != '') {
			evtData.event_label = tag;
		}
		
		gtag('event', action, evtData);
	} else if(typeof ga != 'undefined' && action && category){
		if(tag && tag.trim() != ''){
			ga('send', 'event', action, category, tag);
		}else{
			ga('send', 'event', action, category);
		}
	}
}

function svg(id) {
	return '<span class="svg"><svg class="icon ' + id + '"><use xlink:href="#' + id + '" /></svg></span>';
}

function handleMailtoLink(th) {
	if (th.attr('href') == 'javascript:void(0)') {
		var hidden = th.children('.emailhidden');
		th.attr('href', 'mailto:' + hidden.data('user') + '@' + hidden.data('domain'));
	}
}

function loadJs(url, implementationCode){
    var scriptTag = document.createElement('script');
    scriptTag.src = url;

    scriptTag.onload = implementationCode;
    scriptTag.onreadystatechange = implementationCode;

    document.body.appendChild(scriptTag);
};

function setNavigationUrl(item) {
	var address = item.data('address');
	
	if (address) {
		var protocol = 'google';
		var ua = navigator.userAgent.toLowerCase();
		var plat = navigator.platform;
		var device = ua.match(/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera/i) ? ua.match(/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera/i)[0] : false;

		if(device == 'iphone' || device == 'ipad' || device == 'ipod'){
			function iOSversion() {
					
				if (/iP(hone|od|ad)/.test(navigator.platform)) {
				  var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
				  return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
				}
			}

			var ver = iOSversion() || [0];
			if (ver[0] >= 6) {
				protocol = 'apple';
			}
		}
		
		var urlSuffix = '/?daddr='+address;
		var nav_url = '';
		switch(protocol) {
			case 'apple':
				nav_url = 'maps://';
				break;
			default:
				nav_url = 'https://maps.google.com/maps';
				break;
		}
		item.attr('target', '_blank');
		item.attr('href', nav_url+urlSuffix);
	}
}

function openGallery(item) {
	var groupId = item.data('group-id');
	var index = item.data('index');
	
	if (typeof mediaGroupItems === 'object' && typeof mediaGroupItems[groupId] !== 'undefined') {
		if (!index) {
			index = 0;
		}

		initGallery(item, mediaGroupItems[groupId], index);
	} 
}

function openArticleGallery(item) {
	var groupId = $(item).data('gallery-id');
	if (groupId && typeof articleGalleryItems === 'object' && typeof articleGalleryItems[groupId] !== 'undefined') {
		initGallery(item, articleGalleryItems[groupId]);
	}
}

function initGallery(target, items, index) 
{
	if (!index) {
		index = 0;
	}

	$(target).lightGallery({
		dynamic:true,
		dynamicEl:items,
		index:index,
		hash:false,
		download: false
	});
}

function initGalleries()
{
	if (typeof mediaGroupItems === 'object' && Object.keys(mediaGroupItems).length > 0) {
		$('[data-purpose="gallery-box-item"]:not(.initialized)').each(function(){
			$(this).addClass('initialized');
			$(this).click(function(){
				var id = $(this).data('group-id');
				if (id && typeof mediaGroupItems[id] !== 'undefined') {
					initGallery($(this), mediaGroupItems[id]);
				}
			});
		});
	}
}

function scrollToElement(item_id){
    if(item_id==='body')
        $('html,body').animate({scrollTop: $('body').position().top}, 1000);
    else{
        $('html,body').animate({scrollTop: $('#'+item_id).position().top}, 1000);
    }
}

function initItemsSliderSection(selector, type, customOptions)
{
    if (0 >= $(selector).length) {
        return;
    }

    if (typeof customOptions === 'undefined') {
        customOptions = {};
    }

    var swiperSlider = null;
    var sliderInitialized = false;
    var breakpoint = customOptions.breakpoint || 600;

    var defaults = {
        direction: 'horizontal',
        autoHeight: false,
        enabled: false,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        mousewheel: {
            invert: true,
            sensitivity: 1,
            releaseEdges: false,
            forceToAxis: true,
            eventTarget: '.swiper-container'
        }
    };

    var swiperOptions = $.extend(true, {}, defaults, getSliderOptions(type));

	function initSliderSection() {
		if (sliderInitialized) {
			return;
		}

		if (type === 'festivals' || window.innerWidth > breakpoint) {
			swiperSlider = new Swiper(selector, swiperOptions);
			sliderInitialized = true;
		}
	}

	function checkSliderVisibility() {
		if (type === 'festivals') {
			if (!sliderInitialized) {
				initSliderSection();
			}

			if (window.innerWidth <= breakpoint && swiperSlider && swiperSlider.autoplay) {
				swiperSlider.autoplay.start();
			} else if (swiperSlider && swiperSlider.autoplay) {
				swiperSlider.autoplay.stop();
			}
		} else {
			if (window.innerWidth <= breakpoint && sliderInitialized) {
				swiperSlider.destroy();
				sliderInitialized = false;
			} else if (window.innerWidth > breakpoint && !sliderInitialized) {
				initSliderSection();
			}
		}
	}

    checkSliderVisibility();
    $(document).on('pwstudio.window_width_changed', function () {
       checkSliderVisibility();
    });
}

function getSliderOptions(type)
{
    switch (type) {

        case 'articles':
            return {
                slidesPerView: 3,
                spaceBetween: 30,
                breakpoints: {
                    600: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                        enabled: true,
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                        enabled: true,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                        enabled: true,
                    },
                }
            };
		case 'festivals':
            return {
                slidesPerView: 3,
                spaceBetween: 30,
				autoplay: {
            		delay: 1500,
		            disableOnInteraction: false,
        		},
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                        enabled: true,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                        enabled: true,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                        enabled: true,
                    },
                }
            };
		case 'feedbacks':
			return {
				slidesPerView: 3,
				spaceBetween: 24,
				breakpoints: {
					600: {
						slidesPerView: 3,
						spaceBetween: 11,
						enabled: true,
					},
					768: {
						slidesPerView: 3,
						spaceBetween: 20,
						enabled: true,
					},
					1024: {
						slidesPerView: 3,
						spaceBetween: 24,
						enabled: true,
					},
				}
			};	
        default:
            return {};
    }
}
